export const init = (historyHelper) => {
  const watchVideoLinks = document.querySelectorAll('.js-watch-video-link');

  if (watchVideoLinks.length === 0) {
    return;
  }

  let observer = null;
  if (window.IntersectionObserver) {
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const section = entry.target.dataset.section ? entry.target.dataset.section : 'room_page_photos';

          App.track.event('room_page_interaction', {
            section,
            element: 'watch_video',
            interaction: 'visible',
          });
          observer.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    });
  }

  watchVideoLinks.forEach((link) => {
    if (observer) {
      observer.observe(link);
    }

    link.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const section = e.currentTarget.dataset.section ? e.currentTarget.dataset.section : 'room_page_photos';

      App.track.event('room_page_interaction', {
        section,
        element: 'watch_video',
        interaction: 'click',
      });

      const index = Number(e.currentTarget.dataset.index);
      if (Number.isInteger(index) && window.pswpLightbox) {
        // The lightbox always sits on a mosaic-gallery state so Esc/back/close unwind correctly.
        if (historyHelper.getState() !== 'mosaic-gallery') {
          historyHelper.pushState('mosaic-gallery', 'Mosaic Gallery', '#mosaic-gallery');
        }
        historyHelper.pushState(`lightbox-gallery${index}`, 'Gallery', '#lightbox-gallery');
        window.pswpLightbox.loadAndOpen(index);
      }
    });
  });
};
